import { render, staticRenderFns } from "./EditWorkflow.vue?vue&type=template&id=315bf9b0&"
import script from "./EditWorkflow.vue?vue&type=script&lang=js&"
export * from "./EditWorkflow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports